import { useState, useEffect } from 'react'
import { location } from '../interfaces'
import listFunction from './crudFunctions/listFunction'
import NewLocationModal from './modals/NewLocationModal'
import DeleteLocationModal from './modals/DeleteLocationModal'
import EditLocationModal from './modals/EditLocationModal'
import LocationsList from './components/LocationsList'
import assets from './crudFunctions/assets'

const Locations = () => {
  const [trigger, setTrigger] = useState<boolean>(false)
  const [locations, setLocations] = useState<location[] | null>(null)
  const [showNewLocationModal, setShowNewLocationModal] = useState<boolean>(
    false
  )
  const [
    showDeleteLocationModal,
    setShowDeleteLocationModal
  ] = useState<boolean>(false)
  const [showEditLocationModal, setShowEditLocationModal] = useState<boolean>(
    false
  )
  const [singleLocation, setSingleLocation] = useState<location | null>(null)

  const endpoint: string = 'location/list'
  const listUrl: string = assets.apiUrl + endpoint

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const response = await listFunction(listUrl)

      setLocations(response)
    }
    fetchData()
  }, [trigger, listUrl])

  return (
    <>
      <div className='grid'>
        <button
          className='bg-viper justify-self-center text-white text-3xl px-3 py-2 shadow-lg mt-3'
          onClick={() => setShowNewLocationModal(true)}>
          Nueva Dirección
        </button>
      </div>

      {showNewLocationModal && (
        <NewLocationModal
          setShowNewLocationModal={setShowNewLocationModal}
          setLocations={setLocations}
          locations={locations}
        />
      )}

      {showDeleteLocationModal && (
        <DeleteLocationModal
          setShowDeleteLocationModal={setShowDeleteLocationModal}
          setSingleLocation={setSingleLocation}
          singleLocation={singleLocation}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      )}

      {showEditLocationModal && (
        <EditLocationModal
          setShowEditLocationModal={setShowEditLocationModal}
          singleLocation={singleLocation}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      )}

      {locations ? (
        <LocationsList
          locations={locations}
          setShowDeleteLocationModal={setShowDeleteLocationModal}
          setShowEditLocationModal={setShowEditLocationModal}
          setSingleLocation={setSingleLocation}
        />
      ) : (
        <div className='loader animate-spin mx-auto mt-20 mb-20'></div>
      )}
    </>
  )
}

export default Locations
